/* @import '../../global/min-app.css'; */

:host {
  display: block;
}

/* Size Styling */
.small-primary {
  @apply block px-16px py-8px text-0 md:text-1 font-medium rounded text-white transition-colors whitespace-nowrap;
}

.large-primary {
  @apply block px-24px py-16px text-1 md:text-2 font-medium rounded text-white transition-colors whitespace-nowrap;
}

.large-linkedin {
  @apply block pl-24px py-16px text-1 md:text-2  pr-56px font-medium rounded text-white transition-colors;
  background-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/color-icons/icon-linkedin.svg');
  background-size: 24px;
  background-position:90% center;
  background-repeat: no-repeat;
}

.small-secondary {
  @apply block px-16px py-[6px] text-0 md:text-1 font-medium rounded text-dark-blue transition-colors;
  border: 2px solid var(--dark-blue);
}

.large-secondary {
  @apply block px-24px py-[14px] text-1 md:text-2 font-medium rounded text-dark-blue transition-colors;
  border: 2px solid var(--dark-blue);
}

/* Color Styling  Primary*/
.small-primary.btn-dark-blue,
.large-primary.btn-dark-blue,
.large-linkedin.btn-dark-blue {
  @apply bg-dark-blue text-white;
}

.small-primary.btn-dark-blue:hover,
.large-primary.btn-dark-blue:hover,
.large-linkedin.btn-dark-blue:hover {
  @apply bg-medium-blue ;
}

.small-primary.btn-medium-blue,
.large-primary.btn-medium-blue {
  @apply bg-medium-blue text-white;
}

.small-primary.btn-medium-blue:hover,
.large-primary.btn-medium-blue:hover {
  @apply bg-light-blue ;
}

.small-primary.btn-light-blue,
.large-primary.btn-light-blue,
.large-linkedin.btn-light-blue {
  @apply bg-light-blue text-dark-blue;
}

.small-primary.btn-light-blue:hover,
.large-primary.btn-light-blue:hover,
.large-linkedin.btn-light-blue:hover {
  @apply text-white bg-medium-blue;
}

.small-primary.btn-white,
.large-primary.btn-white {
  @apply bg-white text-dark-blue;
}

.small-primary.btn-white:hover,
.large-primary.btn-white:hover {
  @apply bg-ui-gray-5;
}

.small-primary.btn-maroon,
.large-primary.btn-maroon {
  @apply bg-maroon text-white;
}

.small-primary.btn-maroon:hover,
.large-primary.btn-maroon:hover {
  @apply bg-[#540C3F];
}


.small-primary.btn-yellow,
.large-primary.btn-yellow {
  @apply bg-yellow text-dark-blue;
}

.small-primary.btn-yellow:hover,
.large-primary.btn-yellow:hover {
  @apply bg-[#E4B700];
}

.small-primary.btn-green,
.large-primary.btn-green {
  @apply bg-dark-green text-white;
}

.small-primary.btn-green:hover,
.large-primary.btn-green:hover {
  @apply bg-[#007753];
}


.small-primary.btn-orange,
.large-primary.btn-orange {
  @apply bg-orange text-dark-blue;
}

.small-primary.btn-orange:hover,
.large-primary.btn-orange:hover {
  @apply bg-[#EB5500] ;
}

/* Color Styling Secondary */
.small-secondary.btn-dark-blue,
.large-secondary.btn-dark-blue {
  @apply border-dark-blue text-dark-blue;
}

.small-secondary.btn-dark-blue:hover,
.large-secondary.btn-dark-blue:hover {
  @apply border-medium-blue text-medium-blue;
}

.small-secondary.btn-medium-blue,
.large-secondary.btn-medium-blue {
  @apply border-medium-blue text-medium-blue;
}

.small-secondary.btn-medium-blue:hover,
.large-secondary.btn-medium-blue:hover {
  @apply border-light-blue text-light-blue;
}

.small-secondary.btn-light-blue,
.large-secondary.btn-light-blue {
  @apply border-medium-blue text-medium-blue;
}

.small-secondary.btn-white,
.large-secondary.btn-white {
  @apply  border-white text-white;
}

.small-secondary.btn-white:hover,
.large-secondary.btn-white:hover {
  @apply  border-ui-gray-5 text-ui-gray-5;
}

.small-secondary.btn-maroon,
.large-secondary.btn-maroon {
  @apply  border-maroon text-maroon;
}

.small-secondary.btn-maroon:hover,
.large-secondary.btn-maroon:hover {
  @apply  border-[#540C3F] text-[#540C3F];
}

.small-secondary.btn-yellow,
.large-secondary.btn-yellow {
  @apply  border-yellow text-yellow;
}

.small-secondary.btn-yellow:hover,
.large-secondary.btn-yellow:hover {
  @apply  border-[#E4B700] text-[#E4B700];
}

.small-secondary.btn-green,
.large-secondary.btn-green {
  @apply  border-dark-green text-dark-green;
}

.small-secondary.btn-green:hover,
.large-secondary.btn-green:hover {
  @apply  border-[#007753] text-[#007753];
}

.small-secondary.btn-orange,
.large-secondary.btn-orange {
  @apply border-orange text-orange;
}

.small-secondary.btn-orange:hover,
.large-secondary.btn-orange:hover {
  @apply border-[#EB5500] text-[#EB5500];
}
